import React, { useState } from 'react'
import Card from '../../_library/Card'
import SortableTable from '../../_library/SortableTable'
import { getTableColumns } from '../../utils/sortableTableUtils'
import { deleteFromReferrals } from '../../../_common/core/http_services/brands'
import { showAxiosError } from '../../utils/messenger'
import EmptyBar from '../../_library/EmptyBar'
import LoadingBar from '../../_library/LoadingBar'

const referralsColumns = getTableColumns([
  {
    label: 'ID',
    key: 'id',
  },
  {
    label: 'Client Name',
    key: 'name',
  },
  {
    label: 'Email',
    key: 'referral_partner_email',
  },
  {
    label: 'Status',
    key: 'status',
    showStatusName: true,
  },
])

export const ReferralsByBrand = ({ referrals, brandId, refetch, isLoading }) => {
  const [loadingReferrals, setLoadingReferrals] = useState([])
  return (
    <Card title={'Referrals'}>
      {isLoading ? (
        <LoadingBar />
      ) : referrals.length ? (
        <SortableTable
          data={referrals}
          tableColumns={referralsColumns}
          enableSort={false}
          enableCopyTable={false}
          disableMobileView={true}
          className="child-table"
          actions={[
            {
              label: 'Delete',
              className: 'btn btn-danger',
              icon: 'fa fa-trash fa-fw',
              onClick: async data => {
                try {
                  setLoadingReferrals([...loadingReferrals, data.id])
                  await deleteFromReferrals(brandId, data.id)
                  refetch()
                } catch (e) {
                  showAxiosError(e)
                } finally {
                  setLoadingReferrals(loadingReferrals.filter(id => id !== data.id))
                }
              },
              hide: data => data.status !== 'sent',
              isLoading: data => loadingReferrals.find(id => id === data.id),
            },
          ]}
        />
      ) : (
        <EmptyBar />
      )}
    </Card>
  )
}
